package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CashRegisterConfigHardwareHeaders : TitleEnum {
    RECEIPT_PRINTER,
    KITCHEN_STATIONS,
    EFT,
    /*TSE*/;


    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            RECEIPT_PRINTER -> strings.receiptPrinterSettings
            KITCHEN_STATIONS -> strings.kitchenStations
            EFT -> strings.eft
            //TSE -> strings.tse
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                RECEIPT_PRINTER -> strings.receiptPrinterSettings
                KITCHEN_STATIONS -> strings.kitchenStations
                EFT -> strings.eft
                //TSE -> strings.tse
            }
        }
}